export enum ESuperMasterSelectorType {
  ALL = 'all',
}
